var eventPrefix = 'cp.quickDep';

// message bus events exposed by QuickDeposit component to verticals
// don't put internal events in this file

export var MESSAGE_SUB_QD_OPEN = eventPrefix + '.open';
export var MESSAGE_PUB_QD_CLOSE = eventPrefix + '.close';
export var MESSAGE_PUB_QD_SUCCESS = eventPrefix + '.success';
export var MESSAGE_PUB_QD_FAIL = eventPrefix + '.fail';
export var MESSAGE_PUB_QD_OPEN_DEPOSIT = eventPrefix + '.openDeposit';
export var MESSAGE_PUB_QD_INIT3DS = eventPrefix + '.init3DS';
export var MESSAGE_PUB_QD_CONSENT_CLICK = eventPrefix + '.consentClick';

export default {
    MESSAGE_SUB_QD_OPEN: MESSAGE_SUB_QD_OPEN,
    MESSAGE_PUB_QD_CLOSE: MESSAGE_PUB_QD_CLOSE,
    MESSAGE_PUB_QD_SUCCESS: MESSAGE_PUB_QD_SUCCESS,
    MESSAGE_PUB_QD_FAIL: MESSAGE_PUB_QD_FAIL,
    MESSAGE_PUB_QD_OPEN_DEPOSIT: MESSAGE_PUB_QD_OPEN_DEPOSIT,
    MESSAGE_PUB_QD_INIT3DS: MESSAGE_PUB_QD_INIT3DS,
    MESSAGE_PUB_QD_CONSENT_CLICK: MESSAGE_PUB_QD_CONSENT_CLICK
};